<script setup>
import dayjs from 'dayjs';
import { onMounted } from 'vue';
import { useAuthStore } from '~/stores/auth';

const props = defineProps({
  compromisso: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['loaded']);
const authStore = useAuthStore();

onMounted(() =>
{
  emit('loaded');
});
</script>

<template>
  <a-descriptions
    :column="3"
    :label-style="{ width: '20%' }"
    bordered
  >
    <a-descriptions-item
      v-if="!isNilOrEmpty(props.compromisso.data.seraCumprido)"
      label="Será cumprido?"
      :span="3"
    >
      {{ props.compromisso.data.seraCumprido ? 'Sim' : 'Não' }}
    </a-descriptions-item>

    <a-descriptions-item
      v-if="
        isNil(props.compromisso.data.seraCumprido)
          || props.compromisso.data.seraCumprido === true
      "
      label="Observação"
      :span="3"
    >
      {{ props.compromisso.data?.observacao ?? '-' }}
    </a-descriptions-item>

    <a-descriptions-item
      v-if="props.compromisso.data.seraCumprido === false"
      label="Novo vencimento"
      :span="3"
    >
      {{
        props.compromisso.data.novoVencimento
          ? dayjs
            .utc(props.compromisso.data.novoVencimento)
            .tz(authStore.timeZone)
            .format('DD/MM/YYYY HH:mm')
          : '-'
      }}
    </a-descriptions-item>

    <a-descriptions-item
      v-if="props.compromisso.data.seraCumprido === false"
      label="Justificativa"
      :span="3"
    >
      {{ props.compromisso.data.justificativaParaNaoCumprimento ?? '-' }}
    </a-descriptions-item>

    <a-descriptions-item
      label="Arquivos"
      :span="3"
    >
      <span v-if="props.compromisso.arquivos.length === 0">Nenhum arquivo enviado</span>
      <ul v-else>
        <li
          v-for="arquivo in props.compromisso.arquivos"
          :key="arquivo.fileServiceId"
        >
          <a
            target="_blank"
            :href="getGoogleDriveUrl(arquivo.fileServiceId)"
          >{{
            arquivo.nome
          }}</a>
        </li>
      </ul>
    </a-descriptions-item>
  </a-descriptions>
</template>
